import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export default {
  // 获取商品分组列表
  getgroups: option => {
    return request3('v1/productgroup/getgroups', option, true)
  },
  // 获取商品分组
  getgroup: option => {
    const urls = urlStringify(option)
    return request3('v1/productgroup/getgroup' + urls, {}, true, false)
  },
  // 内容发布 删除
  deletegroup: option => {
    const urls = urlStringify(option)
    return request3('v1/productgroup/deletegroup' + urls, {}, true)
  },
  // 新增商品分组
  addgroup: option => {
    return request3('v1/productgroup/addgroup', option, true, false)
  },
  // 修改商品分组
  updategroup: option => {
    return request3('v1/productgroup/updategroup', option, true, false)
  }
}
